import { User } from '../../utils/models';

// ============================================================
// DUMMY DATA
// Replace these values with real login API data later
// ============================================================

export const DUMMY_USER = {
  user_id: 999001,
  given_name: 'חילאנט',
  family_name: 'משתמש',
  displayName: 'חילאנט משתמש',
  nick_name: 'חילאנט',
  phones: ['0523971371'],
};

// Hard-coded OTP for the dummy login flow until the real Kehilanet auth backend is ready.
export const DUMMY_OTP = '000000';

export const DUMMY_COMMUNITY_ID = 99901;

export const DUMMY_COMMUNITY = {
  id: DUMMY_COMMUNITY_ID,
  name: 'קהילת חילאנט',
};

export const DUMMY_MEMBERS: User[] = [
  {
    user_id: 999002,
    given_name: 'דני',
    family_name: 'כהן',
    displayName: 'דני כהן',
    nick_name: 'דני',
    phones: ['0521234567'],
    is_showInAlphon: true,
  } as User,
  {
    user_id: 999003,
    given_name: 'רונית',
    family_name: 'לוי',
    displayName: 'רונית לוי',
    nick_name: 'רונית',
    phones: ['0531234567'],
    is_showInAlphon: true,
  } as User,
  {
    user_id: 999004,
    given_name: 'יוסי',
    family_name: 'אברהם',
    displayName: 'יוסי אברהם',
    nick_name: 'יוסי',
    phones: ['0541234567'],
    is_showInAlphon: true,
  } as User,
];
